export default __webpack_public_path__ + "static/media/2953962.7e1ca706.jpg";